import { render, staticRenderFns } from "./CouponVipPopup.vue?vue&type=template&id=383e9ba6&scoped=true&"
import script from "./CouponVipPopup.vue?vue&type=script&lang=js&"
export * from "./CouponVipPopup.vue?vue&type=script&lang=js&"
import style0 from "./CouponVipPopup.vue?vue&type=style&index=0&id=383e9ba6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383e9ba6",
  null
  
)

export default component.exports